/* eslint-disable @typescript-eslint/camelcase */
import { Observable } from 'rxjs'
import { actionTypes } from '~/redux/draftEditor'
import { setStoryAns } from '../storyData'
import { errorAction } from '~/redux/commonActions'
import {
  ACTION_ACTIVE_TAB,
  EllipsisTabs,
  previousTab,
  activeTab,
} from '~/redux/appReducer'
import { TRIDENT_ROUTE_COMPOSER_UI } from '~/constants'
import { makeStoryAnsFromReduxState } from '~/util/validation'

export const exportClipboardContent = (clipboardContent) => {
  if (!clipboardContent) {
    return {}
  }
  return Object.keys(clipboardContent)
    .filter(
      (key) => !!clipboardContent[key] && clipboardContent[key].length > 0
    )
    .reduce((acc, key) => {
      acc[key] = clipboardContent[key].map((item) =>
        item.get('clipboardANS').toJS()
      )
      return acc
    }, {})
}

const exportEpic = (action$, store, { serviceResolver, html5RedirectTo }) =>
  action$
    .filter((action) => {
      const saveAction = action.type === actionTypes.ACTION_SAVE
      const weAreOnComposeTab =
        previousTab(store.getState()) === EllipsisTabs.Compose
      const goToNonComposeTab =
        action.type === ACTION_ACTIVE_TAB &&
        action.payload !== EllipsisTabs.Compose
      return (
        saveAction ||
        (weAreOnComposeTab && goToNonComposeTab) ||
        action.type === actionTypes.ACTION_SYNC_EDITOR_CONTENT
      )
    })
    // Convert Draft current content state into ANS
    .mergeMap((action) => {
      const { cloneStory = false } = action.payload || {}
      // got go to another tab we do a mini-save: sync up Angular story object with whatever we have now
      const doNotSave = action.type !== actionTypes.ACTION_SAVE
      // If we save not from compose tab, do not overwrite headlines & subheadlines
      // These were saved to story from draft while we switched out from compose
      const weAreOnComposeTab =
        activeTab(store.getState()) === EllipsisTabs.Compose
      const storyService = serviceResolver('storyService')
      const isLeavingComposeTab =
        previousTab(store.getState()) === EllipsisTabs.Compose &&
        action.type === ACTION_ACTIVE_TAB &&
        action.payload !== EllipsisTabs.Compose
      return (
        Observable.from(storyService.getStory())
          // Since new atomic ANS data is stored part of the EditorState, we need some delay for the final state sync after the flushOnChange event
          .delay(100)
          .mergeMap((story) => {
            const state = store.getState()
            makeStoryAnsFromReduxState(story, state, {
              setHeadlines: weAreOnComposeTab || isLeavingComposeTab,
              isMutableStory: true,
            })
            // Sync story content but don't overwrite the isDirty state -> prevents isDirty = true after switching Composer tabs
            storyService.setStory(story)
            if (doNotSave) {
              return Observable.of(story)
            }
            // Call story service to save story
            return storyService
              .save(true, false, false, cloneStory, true)
              .catch(() => null)
          })
          .map((story) => {
            if (!story) {
              return null
            }
            const { navigateBack, navigateToRevisions } = action.payload || {}

            const isLegacyEnabled = store?.getState()?.settings?.openBeta
              ?.legacyEnabled

            const storyUrl = isLegacyEnabled
              ? `${TRIDENT_ROUTE_COMPOSER_UI}/story/${story._id}/`
              : `${TRIDENT_ROUTE_COMPOSER_UI}/story/${story._id}?allowAngular=true`

            const revisionUrl = isLegacyEnabled
              ? `${TRIDENT_ROUTE_COMPOSER_UI}/story/${story._id}/revision`
              : `${TRIDENT_ROUTE_COMPOSER_UI}/story/${story._id}/revision?allowAngular=true`

            if (navigateBack) {
              html5RedirectTo(storyUrl)
            } else if (navigateToRevisions) {
              html5RedirectTo(revisionUrl)
            }
            return setStoryAns({
              storyAns: story,
              isDirty: false,
            })
          })
          // Return a stream with one element to dispatch - errorAction.
          // will be handled by errorEpic
          .catch((err) => Observable.of(errorAction(err)))
      )
    })
    .filter((action) => !!action)

export default exportEpic
